var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsPictogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Path_46_00000137106282703324891970000012531112476381396905_);}\r\n\t.st1{fill:url(#Path_47_00000119833440419329960410000012477985894010946199_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_46_00000008839615693756581160000006875143927366219148_",
    gradientUnits: "userSpaceOnUse",
    x1: -444.0356,
    y1: 513.9872,
    x2: -444.9416,
    y2: 515.0762,
    gradientTransform: "matrix(15.766 0 0 -14.2441 7045.6982 7380.896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#86BE49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    style: {
      fill: "url(#Path_46_00000008839615693756581160000006875143927366219148_)"
    },
    d: "M44.8,59.7 c0,0.1,0,0.1,0,0.2c-6.9-2.3-12.7-7.3-15.8-13.9c0.9-0.2,1.9-0.3,2.8-0.3C39,45.6,44.8,51.9,44.8,59.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_47_00000138531175629117355750000014652612036992305800_",
    gradientUnits: "userSpaceOnUse",
    x1: -437.6267,
    y1: 533.1318,
    x2: -437.6267,
    y2: 534.1318,
    gradientTransform: "matrix(12.9547 0 0 -32.408 5701.8584 17322.3047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6622"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    style: {
      fill: "url(#Path_47_00000138531175629117355750000014652612036992305800_)"
    },
    d: "M39,25.8 c0.1,7.7-3.9,14.9-10.6,18.8c-1.6-3.7-2.4-7.7-2.4-11.8C26,25.1,29,17.7,34.4,12.2C37.4,16.1,39,20.9,39,25.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsPictogram);
export default __webpack_public_path__ + "static/media/ds-pictogram.f886bf2bddba7b55bef28eefb82ce59c.svg";
export { ForwardRef as ReactComponent };